import type { AuthContext } from '../authMachine'

export async function handleLoginSuccess(_context: AuthContext): Promise<void> {
  // Add small delay like the original delay100 service
  await new Promise((resolve) => {
    setTimeout(resolve, 100)
  })

  // Let the login page handle redirects - no redirect logic here
  // This prevents competing redirects between auth machine and login page
}
